<template>
  <div>
    <NuxtLayout>
      <template #body_page>
        <SectionHero class="bg-hero ">
          <template #title>
            Deliver extraordinary travel for your clients
          </template>
          <template #sub-title>
            Our global network of 250+ Local Designers make delivering extraordinary experiences simple
          </template>
          <template #button>
            <button class="button button-blue" type="button" @click="goto">
              Sign Up as a Travel Agent Today
            </button>
          </template>
        </SectionHero>
        <SectionBenefit>
          <template #titleFirst> Who Is This For? </template>
          <template #contentFirst>
            Designer Journeys is for Travel Agents who have long been searching for a trusted, reliable and simple solution to deliver unique, custom travel experiences for their clients. <br><br> By signing up with Designer Journeys, you will empower your clients to experience the world in extraordinary ways, all whilst being fully supported by our dedicated team and Local Designers on the ground.
          </template>
          <template #imageLargeFirst>
            <img
            class="br-16 mb-w-280"
            src="https://s3-cdn.designerjourneys.com/static/images/user/benefit/bannerLarge.jpg"
            />
          </template>
          <template #imageSmallFirst>
            <img
            class="br-16 absolute right-0 top-220 mb-w-150 mb-top-140"
            src="https://s3-cdn.designerjourneys.com/static/images/user/benefit/bannerSmall.jpg"
            />
          </template>
          
          <template #titleSecond>Why Sign Up With Us </template>
          <template #contentSecond>
            You can explore 1,900+ itineraries filled with unique experiences for design inspiration and marketing purposes. All of these itineraries are customisable, shareable and can be branded with your agency branding. <br><br>
            
            You'll also have direct access to our global network of trusted Local Designers who provide dedicated in-destination support to your client when they are travelling, so you don't have to. <br><br>
            
            Our Travel Concierge Team are on hand 24 hours a day, five days a week to ensure your Local Designer is delivering the right itinerary for your client. This means, you can continue working on other opportunities whilst generating revenue.
          </template>
          <template #imageSecond>
            <img
            class="br-16 mb-w-335"
            src="https://s3-cdn.designerjourneys.com/static/images/user/benefit/bannerSecond.jpg"
            />
          </template>
        </SectionBenefit>
        <SectionQuestion :faqs="faqs" :expandAll="expandAll">
          <template #sub-title>
            Check out our frequently asked questions that Travel Agents like you asked when signing up with Designer Journeys.
          </template>
        </SectionQuestion>
        
        <Reviews :listReviews = listReviews class='pt-50 pb-50 mb-pb-10 mb-pt-60'>
          <template #title>
            Testimonials
          </template>
          <template #sub-title>
            Don't just take our word for it. Read what other Travel Agents love about working with Designer Journeys!
          </template>
        </Reviews>
        <ClientOnly>
          <SectionForm id="form">
            <template #title>Create New Travel Agent Account</template>
            <template #form>
              <form @submit.prevent novalidate autocomplete="off">
                <div class="flex mb-flex-wrap">
                  <div class="mb-12 pr-20 mb-pr-0 mb-wp-100" v-bind:class="{ errorClass : errors.first_name }">
                    <label :class="labelClass" for="firstname">first name</label>
                    <Input
                    type="text"
                    placeholder="First Name"
                    name="firstname"
                    id="firstname"
                    autocomplete="given-name"
                    v-model="form.first_name"
                    @blur="validateInputFirstName"
                    ></Input>
                    <div class="error-message" v-if="errors.first_name">
                      {{ errors.first_name.split('_').join(' ') }}
                    </div>
                  </div>
                  <div class="mb-12 mb-wp-100" v-bind:class="{ errorClass : errors.last_name }">
                    <label :class="labelClass" for="lastname">last name</label>
                    <Input
                    type="text"
                    placeholder="Last Name"
                    name="lastname"
                    id="lastname"
                    autocomplete="family-name"
                    v-model="form.last_name"
                    @blur='validateInputLastName'
                    ></Input>
                    <div class="error-message" v-if="errors.last_name">
                      {{ errors.last_name.split('_').join(' ') }}
                    </div>
                  </div>
                </div>
                <div class="mb-12" v-bind:class="{ errorClass : errors.work_email }">
                  <label :class="labelClass" for="workemail">work email</label>
                  <input name="workemail" disabled="disabled" type="email" style="display:none;">
                  <div class="relative">
                    <Input
                    type="email"
                    placeholder="Work Email"
                    name="workemail"
                    id="workemail"
                    v-model="form.work_email"
                    autocomplete="email"
                    @blur="handleVerifyEmail"
                    @focus="handleEmailFields"
                    :isCard="true"
                    icon="email"
                    >
                      <template #loading v-if="verifyWait">
                  <span class="absolute right-0 top-0 w-36 h-40">
                    <span class='spinner-outer'>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </span>
                  </span>
                      </template>
                    </Input>
                  </div>
                  <div class="error-message" v-if="errors.work_email">
                    <span v-html='errors.work_email'></span>
                  </div>
                </div>
                <!--                          <div class="mb-20" v-bind:class="{ errorClass : errors.password }">
                                              <label :class="labelClass" for="workpassword">password</label>
                                              <input name="workpassword" disabled="disabled" type="password" style="display:none;">
                                              <Input
                                                  type="password"
                                                  placeholder="Password"
                                                  name="workpassword"
                                                  id="workpassword"
                                                  autocomplete="new-password"
                                                  v-model="form.password"
                                                  @blur='validateInputPassword'
                                              ></Input>
                                              <div class="error-message" v-if="errors.password">
                                                  {{ errors.password }}
                                              </div>
                                          </div>-->
                <div class="mb-12" v-bind:class="{ errorClass : errors.phone }">
                  <label :class="labelClass">phone</label>
                  <CountrySelect
                  typeCountry="text"
                  placeholderCountry="Country"
                  placeholderPhone="Phone Number"
                  v-model:country="form.nationality"
                  v-model:phone="form.phone"
                  :key="reRenderCountry"
                  :valueDataCountry="form.nationality"
                  :showDefault='true'
                  @change='validateInputPhone'
                  ></CountrySelect>
                  <div class="error-message" v-if="errors.phone">
                    {{ errors.phone }}
                  </div>
                </div>
                <div class="flex mb-flex-wrap">
                  <div class="mb-12 pr-20 mb-pr-0 mb-wp-100" v-bind:class="{ errorClass : errors.store_name }">
                    <label :class="labelClass" for="store">store name</label>
                    <Input
                    type="text"
                    placeholder="Store Name"
                    name="store"
                    id="store"
                    autocomplete="company"
                    v-model="form.store_name"
                    @blur='validateInputStoreName'
                    ></Input>
                    <div class="error-message" v-if="errors.store_name">
                      {{ errors.store_name.split('_').join(' ') }}
                    </div>
                  </div>
                  <!--                              <div class="mb-20 wp-100" v-bind:class="{ errorClass : errors.postal_code }">
                                                    <div class="flex items-center justify-between mb-8">
                                                      <label
                                                        class="ttu fw-900 fs-11 lh-13 gray-dark dib"
                                                        for="postalCode"
                                                      >postal code</label>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        placeholder="Postal Code"
                                                        name="postalCode"
                                                        id="postalCode"
                                                        autocomplete="postal-code"
                                                        v-model="form.postal_code"
                                                        @blur='validateInputPostalCode'
                                                    ></Input>
                                                    <div class="error-message" v-if="errors.postal_code">
                                                        {{ errors.postal_code.split('_').join(' ') }}
                                                    </div>
                                                </div>-->
                  <div class="mb-12 mb-wp-100" v-bind:class="{ errorClass : errors.company_name }">
                    <label :class="labelClass" for="company">Brand Name</label>
                    <Input
                    type="text"
                    placeholder="Brand Name"
                    name="company"
                    id="company"
                    autocomplete="company"
                    v-model="form.company_name"
                    @blur='validateInputBrandName'
                    ></Input>
                    <div class="error-message" v-if="errors.company_name">
                      {{ errors.company_name.split('_').join(' ') }}
                    </div>
                  </div>
                </div>
                <!--                          <div class="mb-20" v-bind:class="{ errorClass : errors.member_of }">
                                              <div class="flex items-center justify-between mb-8">
                                                  <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib">Member of</label>
                                                  <span class="fs-10 lh-16 gray-dark">optional</span>
                                              </div>
                                              <SelectBox
                                                  :noPlaceholder="true"
                                                  :options="consortiumsList"
                                                  placeholder="Member of"
                                                  v-model:optionSelected="form.consortium"
                                              ></SelectBox>
                                              <div class="error-message" v-if="errors.member_of">
                                                  {{ errors.member_of.split('_').join(' ') }}
                                              </div>
                                          </div>
                                          <div class="mb-20" v-bind:class="{ errorClass : errors.nationality_name }">
                                              <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib" for="country"
                                              >country</label
                                              >
                                              <SelectBox
                                                  :noPlaceholder="true"
                                                  :options="Country"
                                                  placeholder="Country"
                                                  v-model:optionSelected="form.nationality_name"
                                                  @update:optionSelected="onChangeNation"
                                              ></SelectBox>
                                              <div class="error-message" v-if="errors.nationality_name">
                                                  {{ errors.nationality_name.split('_').join(' ') }}
                                              </div>
                                          </div>-->
                
                <div class="tc mb-16 pt-16 mt-4" style='border-top: 1px dashed #DFDFDF'>
                  <ButtonLoading v-if="loading" btnClass='button button-brand-800 wp-100' />
                  <button
                  class="button button-brand-800 wp-100 flex items-center"
                  @click="handleSignUpAgent"
                  v-else>
                    <span>Sign up today</span>
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.648 10.3981L14.648 10.3981L8.39801 16.6481C8.34574 16.7004 8.28369 16.7418 8.2154 16.7701C8.14712 16.7984 8.07393 16.813 8.00001 16.813C7.9261 16.813 7.85291 16.7984 7.78462 16.7701C7.71633 16.7418 7.65428 16.7004 7.60202 16.6481C7.54975 16.5958 7.50829 16.5338 7.48001 16.4655C7.45172 16.3972 7.43716 16.324 7.43716 16.2501C7.43716 16.1762 7.45172 16.103 7.48001 16.0347C7.50829 15.9664 7.54975 15.9044 7.60202 15.8521L13.4106 10.0443L13.4548 10.0001L13.4106 9.95591L7.60202 4.1481C7.60202 4.1481 7.60202 4.14809 7.60202 4.14809C7.49646 4.04254 7.43716 3.89938 7.43716 3.7501C7.43716 3.60083 7.49646 3.45766 7.60202 3.35211C7.70757 3.24656 7.85074 3.18726 8.00001 3.18726C8.14929 3.18726 8.29245 3.24656 8.39801 3.35211L14.648 9.60211L14.648 9.60213C14.7003 9.65438 14.7418 9.71641 14.7701 9.7847C14.7984 9.85299 14.813 9.92618 14.813 10.0001C14.813 10.074 14.7984 10.1472 14.7701 10.2155C14.7418 10.2838 14.7003 10.3458 14.648 10.3981Z" fill="#FAFAFA" stroke="white" stroke-width="0.125"/>
                    </svg>
                  </button>
                </div>
                <div class="fs-16 lh-18 black tc">
                  By continuing, you agree to Designer Journeys'
                  <span class="hand underline fw-600" @click="toTermOfUse">Terms of Use.</span>
                </div>
              </form>
            </template>
            <template #error>
              <div
              id="errorMessages"
              class="red bg-red-900 tc pt-20 pb-20 pl-30 pr-30 mt-23 wp-100 maxw-610 lh-17"
              style="margin-left: auto; margin-right: auto;"
              v-if="messageError"
              v-html="messageError"
              >
              </div>
            </template>
          </SectionForm>
        </ClientOnly>
      </template>
    </NuxtLayout>
  </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import SectionHero from '~/components/sections/SectionHero/SectionHero'
import SectionBenefit from '~/components/pages/User/sections/SectionBenefit/SectionBenefit'
import SectionQuestion from '~/components/sections/SectionQuestion/SectionQuestion'
import Reviews from '~/components/sections/SectionReview/Reviews'
import SectionForm from '~/components/pages/User/sections/SectionForm/SectionForm'
import Input from '~/components/ui/input/Input'
import SelectBox from '~/components/ui/selectbox/SelectBox'
import CountrySelect from '~/components/ui/country-selectbox/CountrySelect'
import countryList from '~/components/ui/country-selectbox/country.json'
import {onBeforeRouteLeave, useRouter} from 'vue-router'
import { computed, onMounted, reactive, ref, watchEffect } from 'vue'
import { load } from 'recaptcha-v3'
import parsePhoneNumber from 'libphonenumber-js'
import useFormValidation from '~/utils/validators'
import { getCookie, setCookie } from '~/mixins/cookie'
import ButtonLoading from '~/components/ui/loading-button/ButtonLoading'
import { getCountryPhone, publicDomain } from '~/helper'
// import accountApi from '~/composables/api/accountApi'
// import Metadata from '~/assets/meta_data.json'
import { useGetCookie } from '~/composables/common/useCustomCookie'
import { useAuthStore } from '~/store/pinia/auth'

export default {
  name: 'SignUp Agent',
  components: {
    SectionHero,
    SectionBenefit,
    SectionQuestion,
    Reviews,
    SectionForm,
    Input,
    SelectBox,
    CountrySelect,
    ButtonLoading
  },
  setup() {
    const domain = publicDomain()
    const router = useRouter()
    // const route = useRoute()
    const Country = ref(countryList)
    const authStore = useAuthStore()
    const loading = ref(false)
    const disabled = ref(true)
    const messageError = ref('')
    // const consortiumsList = ref()
    const reRenderCountry = ref(0)
    const verifyWait = ref(false)
    const preEmail = ref('')
    const verifyEmailDone = ref(false)
    // const runtime = useRuntimeConfig()
    const country_code = useGetCookie('country_code')
    const country_name = useGetCookie('country_name')
    const expandAll = ref(true)
    const labelClass = 'ttc fw-500 fs-16 lh-24 gray-950 mb-8 dib'
    const { $logger } = useNuxtApp()
    
    const listReviews = [
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/valerie.jpg', author: 'Valerie B.', content:'Designer Journeys has an extensive list of travel talent. Their designers are either local or have in-depth knowledge of the destination. Designer Journeys offers a rich and varied range of itineraries that are reasonably priced to luxury priced. You can choose an itinerary "as is" or have any element adjusted or even request a fully customised one. The Designers are flexible, offer insight and suggestions and try to create the expected client experience - regardless of the level of travel investment. ' },
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/georgie.jpg', author: 'Georgie B.', content:'The Designers support clients while in destination. A valuable resource. The Concierge Team monitors and supports the process and interactions between Travel Agent and the Designer. The itinerary is white labelled for the Travel Agent and presented with Gross or Net pricing.  '+'<br><br>'+'Designer Journeys save me precious time and provide me with excellent products that my clients love. #winning '},
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/lexi.jpg', author: 'Lexi D.', content:'The website is very easy to use and puts you directly in touch with the local designer who is very responsive. The local designer has also listened to what we want and planned an incredible trip for us. Couldn’t recommend Tripfuser [now Designer Journeys] more!' },
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/valerie.jpg', author: 'Valerie B.', content:'Designer Journeys has an extensive list of travel talent. Their designers are either local or have in-depth knowledge of the destination. Designer Journeys offers a rich and varied range of itineraries that are reasonably priced to luxury priced. You can choose an itinerary "as is" or have any element adjusted or even request a fully customised one. The Designers are flexible, offer insight and suggestions and try to create the expected client experience - regardless of the level of travel investment. ' },
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/georgie.jpg', author: 'Georgie B.', content:'The Designers support clients while in destination. A valuable resource. The Concierge Team monitors and supports the process and interactions between Travel Agent and the Designer. The itinerary is white labelled for the Travel Agent and presented with Gross or Net pricing.  '+'<br><br>'+'Designer Journeys save me precious time and provide me with excellent products that my clients love. #winning '},
      {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/lexi.jpg', author: 'Lexi D.', content:'The website is very easy to use and puts you directly in touch with the local designer who is very responsive. The local designer has also listened to what we want and planned an incredible trip for us. Couldn’t recommend Tripfuser [now Designer Journeys] more!' },
    
    ];
    
    const faqs = ref([
      {
        id: 1,
        title: 'Who is Designer Journeys?',
        text: 'Designer Journeys’ delivers unique travel experiences through its global network of Local Designers who are deeply knowledgeable travel experts that design, build and deliver extraordinary travel experiences. Designer Journeys has Local Designers in over 70 countries around the world and specialises in custom travel for individuals and groups looking for premium, unique, hard-to-find travel experiences. Established in 2017, the company operated as Tripfuser until August 2021 when it underwent a rebrand to Designer Journeys to better convey the premium nature and uniqueness of the service offered to Travel Agents and Travellers.',
      },
      {
        id: 2,
        title: 'Who are Designer Journeys’ Local Designers?',
        text: 'Designer Journeys’ global network of Local Designers are hand-selected, deeply knowledgeable local travel experts that deliver unique experiences and on-the-ground support for travellers. Local Designers are made up of in-destination inbound travel agents, tour operators, destination management teams and accommodation providers that build custom travel experiences and curated travel packages with their local knowledge and destination insight. All of Designer Journeys’ Local Designers complete an intensive selection process to ensure they are reliable, vetted, trustworthy and deliver quality travel experiences every time.',
      },
      {
        id: 3,
        title: 'What Makes Designer Journeys Different From Other Online Travel Providers?',
        text: 'The premium nature of our service is what sets us apart from the rest. This enables us to design extraordinary travel for your clients who are looking for unique, hard-to-find travel experiences. Once your clients are in destination, if they need to change activities, require a restaurant recommendation or something unforeseen happens, our Local Designers are on hand to lend assistance, providing great peace of mind for both you and your clients.',
      },
    ])
    
    const goto = () => {
      let element = document.getElementById("form");
      element.scrollIntoView({behavior: "smooth"});
    }
    
    const toTermOfUse = () => {
      //router.push({ path: '/terms-of-use' })
      let routerLink = router.resolve({name: 'terms-of-use'});
      window.open(routerLink.href, '_blank');
    }
    
    // const recaptchaKey = ref('')
    // const onLoadRecaptcha = async () => {
    //   disabled.value = false
    //   messageError.value = ''
    //   /* Load recaptcha */
    //   const recaptcha = await load(`${process.env.VUE_APP_SITE_KEY_GRECAPTCHA}`)
    //   recaptchaKey.value = await recaptcha.execute('register')
    // }
    //
    // onMounted(async () => {
      // debounceAmplitudeScriptTracking("View Become a Travel Agent")
      /*const { data } = await accountApi.getConsortiums();

      consortiumsList.value = [ {
        name: "None",
        company_name: "None",
        travel_company_id: null
      },...data.data.map(item => {
        item.name = item.company_name;
        return item
      })];*/
      //   onLoadRecaptcha()
    // })
    
    onBeforeRouteLeave(() => {
      errors.first_name = ''
      errors.last_name = ''
      errors.work_email = ''
      errors.phone = ''
      errors.company_name = ''
      errors.store_name = ''
      /*errors.nationality_name = ''
      errors.postal_code = ''
      errors.nationality = ''
      errors.password = ''
      errors.member_of = ''*/
      disabled.value = true
    })
    
    const {
      validateNameField,
      validateEmailField,
      /*validateNumberField,*/
      validatePasswordField,
      validatePhoneNumberField,
      errors,
    } = useFormValidation()
    
    /* Handle Sign Up */
    const form = reactive({
      first_name: '',
      last_name: '',
      work_email: '',
      phone: '',
      store_name: '',
      nationality_name: {
        code: country_code.value,
        name: country_name.value
      },
      postal_code: '',
      consortium: {
        name: "None",
        company_name: "None",
        travel_company_id: null
      },
      nationality: country_code.value,
      password: '',
      company_id: 0,
      company_name: '',
      receive_newsletter: false
    })
    
    /* detect country code while api called completed for first time */
    if (!form.nationality) {
      // let timesRun = new Date().getTime();
      form.nationality = country_code.value
      
      // let interval = setInterval(() => {
      //   if (country_code.value) {
      //     clearInterval(interval)
      //   }
      if (form.nationality !== country_code.value) {
        form.nationality = country_code.value
        form.nationality_name = {
          code: country_code.value,
          name: country_name.value
        }
      }
      // if(new Date().getTime() - timesRun > 7000){
      //   clearInterval(interval);
      // }
      // }, 500)
    }
    
    const onChangeNation = () => {
      // form.nationality = value.code
      reRenderCountry.value += 1
    }
    
    /* Watch format number phone */
    watchEffect(()=>{
      let phoneNumber = parsePhoneNumber(form.phone, form.nationality)
      if (phoneNumber) {
        form.phone = phoneNumber.nationalNumber
      }
    })
    
    /*const handleCheckCompany = async() => {
      await store.dispatch('authStore/checkCompany', { email: form.work_email })
      const state = computed(() => authStore.auth)
      if(state.value.company_id !== 0){
        form.company_id = state.value.company_id
        form.company_name = ''
      }
    }*/
    
    const validateInputFirstName = () => {
      validateNameField('first_name', form.first_name)
    }
    
    const validateInputLastName = () => {
      validateNameField('last_name', form.last_name)
    }
    // const validateInputNationalityName = () => {
    //   validateNameField('nationality_name', form.nationality_name.code)
    // }
    
    // const validateInputPostalCode = () => {
    //   validateNameField('postal_code', form.postal_code)
    // }
    const validateInputBrandName = () => {
      validateNameField('company_name', form.company_name)
    }
    const validateInputStoreName = () => {
      validateNameField('store_name', form.store_name)
    }
    const validateInputPhone = () => {
      validatePhoneNumberField('phone', form.phone, form.nationality)
    }
    // const validateInputPassword = () => {
    //   validatePasswordField('password', form.password)
    // }
    
    const handleSignUpAgent = async () => {
      validateNameField('first_name', form.first_name)
      validateNameField('last_name', form.last_name)
      // validateNameField('nationality_name', form.nationality_name.code)
      // validateNameField('postal_code', form.postal_code)
      validateNameField('company_name', form.company_name)
      validateNameField('store_name', form.store_name)
      validateEmailField('work_email', form.work_email, 'auth')
      validatePhoneNumberField('phone', form.phone, form.nationality)
      // validatePasswordField('password', form.password)
      if (
      !errors.first_name &&
      !errors.last_name &&
      !errors.work_email &&
      !errors.phone &&
      /*!errors.password &&
      !errors.postal_code &&
      !errors.nationality_name.code &&*/
      !errors.store_name &&
      !errors.company_name
      ) {
        loading.value = true
        try {
          let country_code = form.nationality || getCookie('country_code=')
          let dial_code = getCountryPhone(country_code)
          
          const recaptcha = await load(`${useAppConfig().siteKeyGreCaptcha}`)
          const token = await recaptcha.execute('register')
          
          let signupSubmit = {
            first_name: form.first_name,
            last_name: form.last_name,
            email: form.work_email,
            phone: dial_code.concat(form.phone),
            store_name: form.store_name,
            nationality: getCookie('country_code='), // form.nationality,
            company_name: form.company_name,
            'g-recaptcha-response': token,
            currency: getCookie('dj_curr=')
          }
          
          await authStore.signUpAgent(signupSubmit)
          const state = computed(() => authStore.auth)
          
          signupSubmit = JSON.stringify(signupSubmit)
          sessionStorage.setItem('signup-submit', signupSubmit)
          
          loading.value = false
          if(domain === 'agent'){
            if (state.value.error === 0) {
              
              const COOKIE_DURATION = 365
              setCookie('is_verified', 1, COOKIE_DURATION)
              setCookie('dj_xxer_hash', state.value.hash, COOKIE_DURATION)
              if (router.options.history.state.back !== null) {
                router.go(-1)
              } else {
                router.push({ path: `/sign-up-success ` })
              }
            } else {
              messageError.value = state.value.message
              // loading.value = false
            }
          } else{
            // loading.value = false
            if (state.value.error === 0) {
              router.push(`/sign-up-travel-agent/success`)
              // window.location.replace(`${process.env.VUE_APP_PUBLIC_DOMAIN_AGENT}/sign-up-success`)
            } else{
              messageError.value = state.value.message
            }
            
          }
        } catch (err) {
          console.log(err)
          $logger.log(err)
        }
      }
    }
    
    const isCustomer = computed(() => authStore.auth.is_customer)
    const isValid = computed(() => authStore.auth.is_valid)
    const handleVerifyEmail = async() => {
      validateEmailField('work_email', form.work_email, 'auth')
      
      if((preEmail.value !== form.work_email) && !errors.work_email) {
        // msgErr.value = ""
        verifyEmailDone.value = false
        verifyWait.value = true
        
        const res = await authStore.verifyEmail(
        {
          email: form.work_email,
          source: 'signup_agent'
        })
        
        if(res.error === 0){
          if(isValid.value === 1 && isCustomer.value === 1){
            errors.work_email =  `An account with this email address already exists. <a style='color: #0058c1' href='${useAppConfig().publicDomainAgent}/login'><span style='color: #0058c1'>Please login</span</a>`
          }
          verifyEmailDone.value = true
          verifyWait.value = false
        } else {
          verifyWait.value = false
          // msgErr.value = res.message
          errors.work_email = res.message
        }
      }
      else {
        verifyEmailDone.value = true
      }
    }
    
    const handleEmailFields = () => {
      // errors.work_email = ''
      // verifyEmailDone.value = false
      preEmail.value = form.work_email
    }
    
    onMounted(() => {
      expandAll.value = false
      debounceAmplitudeScriptTracking("View Become a Travel Agent")
    })
    
    return {
      Country,
      expandAll,
      goto,
      handleSignUpAgent,
      /*handleCheckCompany,*/
      toTermOfUse,
      form,
      loading,
      errors,
      disabled,
      messageError,
      listReviews,
      onChangeNation,
      reRenderCountry,
      /*consortiumsList,*/
      faqs,
      handleVerifyEmail,
      handleEmailFields,
      verifyWait,
      validateInputFirstName,
      validateInputLastName,
      /*validateInputNationalityName,
      validateInputPostalCode,*/
      validateInputBrandName,
      validateInputStoreName,
      validateInputPhone,
      /*validateInputPassword,*/
      labelClass
    }
  },
}
</script>
<style lang='scss' scoped>
//@import "src/assets/scss/src/_spinner.scss";
.bg-hero {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 67.64%), url('https://s3-cdn.designerjourneys.com/static/images/user/bg-agent.jpg'), #EEF7F9;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  height: 340px;
}
</style>
